import { patchRequest } from '@/core';
import { incoterms } from '@/requests';

export default async function updateIncotermRequest(id, patch) {
	let url = incoterms.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}